export const SIZE = {
    XXL: "XXL",
    XL: "XL",
    LG: "LG",
    L: "L", //equal to large
    MD: "MD",
    M: "M", //equal to medium
    SM: "SM",
    S: "S", //equal to small
    XS: "XS",
}